import amlon from "./amlon";
import bllon from "./bllon";
import perlon from "./perlon";
import pemlon from "./pemlon";
import odalon from "./odalon";
import odprd from "./odprd";

export default {
    amlon,
    bllon,
    perlon,
    pemlon,
    odalon,
    odprd
}